module.exports = __webpack_public_path__ + "img/shadoji_card_image.588ca487.jpg";